// extracted by mini-css-extract-plugin
module.exports = {"tabContent":"BillingSummaryPage_tabContent__293Mr","billingSummaryContainer":"BillingSummaryPage_billingSummaryContainer__1Y-9c"};